import { api } from "../../shared/api/axios";

const unwrap = (data) => (Array.isArray(data) ? data : data.data ?? []);

export async function fetchColletos() {
  const { data } = await api.get("/colletos");
  return unwrap(data);
}

export async function fetchAssignments() {
  const { data } = await api.get("/lockers");
  return unwrap(data);
}

export async function assignLocker(payload) {
  const { data } = await api.post("/lockers", payload);
  return data;
}

export async function unassignLocker(id) {
  const { data } = await api.patch(`/lockers/${id}/unassign`);
  return data;
}
